var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{staticStyle:{"margin-top":"30px"},attrs:{"width":"600","height":"40","preserveAspectRatio":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }